module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/btn-add-d578d6b7db59e7941af2c3834691eb7a.png";